{
  "label": "Options d'écoute en continu",
  "close": "Fermer",
  "noLinksTitle": "Aucune option de diffusion en continu",
  "noLinksDescription": "Nous n'avons trouvé aucun lien vers cette chanson sur les services de diffusion de musique en continu."
}
